import { FormControlValidator } from '../use-form-control';

export function RegexValidator(regex: RegExp, customMsg?: string): FormControlValidator {
  return (val) => {
    if (val && val.length && !regex.test(val)) {
      return {
        valid: false,
        errors: [{ msg: customMsg || `The value provided doesnt match the custom filter for this field.` }],
      };
    }
    return { valid: true };
  };
}
